module.exports = __webpack_public_path__ + "static/media/cornfield.85b06afb.jpg";